import ButtonBlue from "../../components/ButtonBlue";
import useStyles from "./styles/yourprogram";
import { withTranslation } from "../../i18n";
import { Hidden } from "@material-ui/core";

const YourProgram = ({ t, i18n, redirect }) => {
    const classes = useStyles();
    const lang = i18n.language

    function renderTitle() {
        if (lang === 'id') {
            return (
                <h2 className={classes.title}>Program Kamu, Sesuai Keinginanmu</h2>
            )
        }
        return (
            <h2 className={classes.title}>Your Program,{" "}
                <Hidden smUp>
                    <br />
                </Hidden>
                Your Way</h2>
        )
    }
    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.ctnLeft}>
                    <img src={`/static/new-landing-page/your-program/program_${lang}.webp`} srcSet={`/static/new-landing-page/your-program/program_${lang}_560w.webp 560w, /static/new-landing-page/your-program/program_${lang}.webp 754w`} sizes="(min-width: 600px) 380px, calc(100vw - 96px)" alt="your-program" loading="lazy" />
                </div>
                <div className={classes.ctnRight}>
                    {renderTitle()}
                    <span className={classes.subTitle}>{t("find-your-program-desc")}</span>
                    <ButtonBlue isPulse onClick={redirect} label={t("personalize-your-program")} />
                </div>
            </div>

        </div>
    );
};

export default withTranslation(["myfitsociety"])(YourProgram);